import { render } from "./Ippsu.vue?vue&type=template&id=079d99cc&scoped=true"
import script from "./Ippsu.vue?vue&type=script&lang=js"
export * from "./Ippsu.vue?vue&type=script&lang=js"

import "./Ippsu.vue?vue&type=style&index=0&id=079d99cc&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079d99cc"]])

export default __exports__